export default __webpack_public_path__ + "static/Centralize-data-767eeb90c94e054dc8a99f03ceb6b5e6.png";